import './BrokerModal.scss'
import React, {Component} from 'react'
import {Button, Modal} from 'react-bootstrap'
import { connectModal } from 'redux-modal'

import {removeBrokerUser, updateBrokerContact} from 'broker/redux/account'
import Select from "react-select";
import {UsersListAvatar} from "broker/views/components/ManageUsers/UsersList";

export const RemoveBrokerContactModalState = {
  DEFAULT : 'default',
  CONFIRM_CONTINUE_TO_SELECT: 'internal-continue-to-selection',
  SELECT_AND_DELETE: 'select-new-contact'
}

class RemoveBrokerContact extends Component {
  constructor(props) {
    super(props)
    const broker_contact_options = this.buildContactOptions(this.props.contacts)
    const modal_state = this.props.can_remove ? RemoveBrokerContactModalState.CONFIRM_CONTINUE_TO_SELECT : RemoveBrokerContactModalState.DEFAULT
    this.state = {modal_state: modal_state, contacts: broker_contact_options, newContact: broker_contact_options[0]}
    this.handleFinish = this.handleFinish.bind(this)
    this.handleUpdateBrokerContact = this.handleUpdateBrokerContact.bind(this)
    this.handleSelectNewContact = this.handleSelectNewContact.bind(this)
  }

  buildContactOptions = (contacts) => {
    const filtered_contacts = contacts.filter((contact) => contact.email !== this.props.contact_to_remove.email)
    return filtered_contacts.map((contact) => {
      const fullName = [contact.first_name, contact.last_name].join(' ').trim()
      const label = fullName ? `${fullName}: ${contact.email}` : contact.email
      return {label: label, value: contact}
    })
  }

  handleFinish() {
    this.props.handleHide()
  }

  handleSelectNewContact() {
    this.setState({
      modal_state: RemoveBrokerContactModalState.SELECT_AND_DELETE
    })
  }


  handleUpdateBrokerContact() {
    this.props.dispatch(updateBrokerContact(this.props.broker_hash, this.state.newContact.value.user_id)
    ).then((response) =>{
       if (response.success) {
          this.props.dispatch(removeBrokerUser(this.props.contact_to_remove.id))
       }
      this.props.handleHide()
    })

  }

  getModalComponents(contact) {
    const displayName = [contact.first_name, contact.last_name].join(' ').trim() || contact.email
    const header = <Modal.Header className="RemoveAgentModal__default-header">
          <Modal.Title>Remove Admin</Modal.Title>
        </Modal.Header>

    let body, footer
    switch (this.state.modal_state) {
      case RemoveBrokerContactModalState.DEFAULT:


        body = <Modal.Body>
          <div className="RemoveAgentModal__disabled">
            <div className="RemoveAgentModal__disabled__summary">
              <p> <strong>{displayName}</strong> is the current broker contact. </p>
              <p> Please contact Broker Support if you would like to remove this admin.</p>
            </div>
          </div>
        </Modal.Body>
        footer = <Modal.Footer>
          <Button onClick={this.props.handleHide}>Close</Button>
        </Modal.Footer>
        break

      case RemoveBrokerContactModalState.CONFIRM_CONTINUE_TO_SELECT:
        body = <Modal.Body>
          <div className="RemoveAgentModal__disabled">
            <div className="RemoveAgentModal__disabled__summary">
              <p> <strong>{displayName}</strong> is the broker contact for this account.</p>
              <p>Are you sure you want to continue? A new broker contact must be selected from the current admins on this account.</p>
            </div>
          </div>
        </Modal.Body>

        footer =  <Modal.Footer>
            <Button bsStyle="primary" onClick={this.handleSelectNewContact}>Confirm</Button>
            <Button onClick={this.props.handleHide}>Cancel</Button>
        </Modal.Footer>
        break

      case RemoveBrokerContactModalState.SELECT_AND_DELETE:
        body = <Modal.Body className="RemoveBrokerContactModal__confirm-delete">
          <div className="RemoveBrokerContactModal__confirm-delete__details">
            <strong>Current Broker Contact: </strong>
          </div>
          <div className="RemoveBrokerContactModal__user_avatar">
            <div>
              <UsersListAvatar {...contact} />
            </div>
          </div>

          <div className="RemoveBrokerContactModal__confirm-delete__details__contact">
            <strong>New Broker Contact: </strong>
          </div>
          <Select
              value={this.state.newContact}
              clearable={false}
              backspaceRemoves={false}
              searchable={false}
              onChange={e => {
                this.setState({
                  newContact: e
                })
              }}
              options={this.state.contacts}
          />
        </Modal.Body>

        footer =  <Modal.Footer>
          <Button bsStyle="danger" onClick={this.handleUpdateBrokerContact}>Update Contact and Remove Admin</Button>
          <Button onClick={this.props.handleHide}>Cancel</Button>
        </Modal.Footer>
        break

    }
    return {
      header,
      body,
      footer
    }
    }

  render() {
    const layout = this.getModalComponents(this.props.contact_to_remove)
    return (
      <Modal className="RemoveBrokerContactModal" show={this.props.show}>
        {layout.header}
        {layout.body}
        {layout.footer}
      </Modal>
    )
  }
}

const RemoveBrokerContactModal = connectModal({ name: 'RemoveBrokerContactModal', destroyOnHide: true })(RemoveBrokerContact)

export default RemoveBrokerContactModal
